export default __webpack_public_path__ + "static/media/call me.7942bb56.jpg";